import Icon from "components/Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";
import React, { useState, useEffect } from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";

const FormNotifications = ({
  potentialCustomers,
  setPotentialCustomers,
  customersFilesDownloaded,
  setCustomersFilesDownloaded,
  orderConfirmation,
  setOrderConfirmation,
   sendEmailToRecipients,
                setSendEmailToRecipients,
  setUpdateBeforeSave,
}) => {
  const { getTextByKey } = useContent();
  const [tempPotential, setTempPotential] = useState(potentialCustomers);
  const [tempFilesDownloaded, setTempFilesDownloaded] = useState(
    customersFilesDownloaded
  );
  const [tempOrderConfirmation, setTempOrderConfirmation] =
    useState(orderConfirmation);
    const [tempSendEmailToRecipients, setTempSendEmailToRecipients] = useState(
      sendEmailToRecipients
    );
  const [updateNotifications, setUpdateNotifications] = useState(false);

  useEffect(() => {
    if (tempPotential !== potentialCustomers) {
      setUpdateNotifications(true);
      setTempPotential(potentialCustomers);
    }

     if (tempSendEmailToRecipients !== sendEmailToRecipients) {
       setUpdateNotifications(true);
       setTempSendEmailToRecipients(sendEmailToRecipients);
     }

    if (tempFilesDownloaded !== customersFilesDownloaded) {
      setUpdateNotifications(true);
      setTempFilesDownloaded(customersFilesDownloaded);
    }

    if (tempOrderConfirmation !== orderConfirmation) {
      setUpdateNotifications(true);
      setTempOrderConfirmation(orderConfirmation);
    }
  }, [
    potentialCustomers,
    customersFilesDownloaded,
    orderConfirmation,
    sendEmailToRecipients,
  ]);

  useEffect(() => {
    if (updateNotifications) {
      setUpdateBeforeSave({ mode: true, action: "updateNotifications" });
      setUpdateNotifications(false);
    }
  }, [updateNotifications]);

  return (
    <div className="notifications-options option">
      <div className="notify-me">
        <div className="notify-title">
          <span className="">{getTextByKey("notify-me")}</span>
        </div>
        <div className="input-status-div">
          <Image
            className="input-checkbox"
            onClick={(e) => {
              setSendEmailToRecipients((prev) => !prev);
            }}
            name={
              sendEmailToRecipients ? "checkbox-checked" : "checkbox-unchecked"
            }
            ext="svg"
          />
          <div className="text-and-tooltip">
            {" "}
            <span className="span-text">
              {getTextByKey("send-email-to-recipients-text")}
            </span>{" "}
            <Tooltip
              id={"send-email-to-recipients-tooltip-id"}
              tooltipTextKey="send-email-to-recipients-tooltip"
              //hardPositioned
              top
            >
              <Icon name="question-circle" iconClass="tooltip-question" />
            </Tooltip>
          </div>
        </div>
        <div className="input-status-div">
          <Image
            className="input-checkbox"
            onClick={(e) => {
              setPotentialCustomers((prev) => !prev);
            }}
            name={
              potentialCustomers ? "checkbox-checked" : "checkbox-unchecked"
            }
            ext="svg"
          />
          <div className="text-and-tooltip">
            {" "}
            <span className="span-text">
              {getTextByKey("potential-customers-leads")}
            </span>{" "}
            <Tooltip
              id={"potential-customers-tooltip-id"}
              tooltipTextKey="potential-customers-leads-tooltip"
              //hardPositioned
              top
            >
              <Icon name="question-circle" iconClass="tooltip-question" />
            </Tooltip>
          </div>
        </div>
      </div>
      <div className="notify-customers">
        <div className="notify-title">
          <span className="notify-title">
            {getTextByKey("notify-customers")}
          </span>
        </div>
        <div className="input-status-div">
          <Image
            className="input-checkbox"
            onClick={(e) => {
              setCustomersFilesDownloaded((prev) => !prev);
            }}
            name={
              customersFilesDownloaded
                ? "checkbox-checked"
                : "checkbox-unchecked"
            }
            ext="svg"
          />
          <div className="text-and-tooltip">
            <span className="span-text">
              {getTextByKey("notify-customer-when-downloaded")}
            </span>{" "}
            <Tooltip
              id={"files-downloaded"}
              tooltipTextKey="notify-customer-when-downloaded-tooltip"
              //hardPositioned
              top
            >
              <Icon name="question-circle" iconClass="tooltip-question" />
            </Tooltip>
          </div>
        </div>
        <div className="input-status-div">
          <Image
            className="input-checkbox"
            onClick={(e) => {
              setOrderConfirmation((prev) => !prev);
            }}
            name={orderConfirmation ? "checkbox-checked" : "checkbox-unchecked"}
            ext="svg"
          />
          <div className="text-and-tooltip">
            {" "}
            <span className="span-text">
              {getTextByKey("send-order-confirmation")}
            </span>{" "}
            <Tooltip
              id={"order-confirmation"}
              tooltipTextKey="send-order-confirmation-tooltip"
              //hardPositioned
              top
            >
              <Icon name="question-circle" iconClass="tooltip-question" />
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormNotifications;
